module.exports = __webpack_public_path__ + "static/media/021-rain-2.364ec52b.svg";